import "./styles/App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Puppies from "./pages/Puppies";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import Studs from "./pages/Studs";
import BookStud  from "./pages/BookStud";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import Register from "./pages/Register";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import PuppyApplicationPage from "./pages/PuppyApplicationPage";
import PuppyApplicationReviewPage from "./pages/PuppyApplicationReviewPage";
import PuppyApplicationSuccessPage from "./pages/PuppyApplicationSuccessPage";
import PuppyApplicationFailedPage from "./pages/PuppyApplicationFailedPage";
import Admin from "./pages/Admin";
import RequireAdmin from "./components/RequireAdmin";
import ScrollToTop from "./components/ScrollToTop";


// This component handles routing and the footer logic
function AppContent() {
  const location = useLocation();

  // Paths where Footer should be hidden
  const hideFooterPaths = ["/login", "/register", "/admin", "/contact"];
  const shouldHideFooter = hideFooterPaths.some((path) =>
    location.pathname.startsWith(path)
  );

  return (
    <div className="app-wrapper">
      <Navbar />
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/puppies" element={<Puppies />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/studs" element={<Studs />} />
          <Route path="/book/:studId" element={<BookStud />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/puppy-application" element={<PuppyApplicationPage />} />
          <Route
            path="/puppy-application/review"
            element={<PuppyApplicationReviewPage />}
          />
          <Route
            path="/puppy-application/success"
            element={<PuppyApplicationSuccessPage />}
          />
          <Route
            path="/puppy-application/failed"
            element={<PuppyApplicationFailedPage />}
          />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <Admin />
              </RequireAdmin>
            }
          />
      </Routes>
      {!shouldHideFooter && <Footer />}
    </div>
  );
}

// Router must wrap AppContent so useLocation works
function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;
